import { PortSelectInput } from "components/inputs/PortSelectInput";
import React from "react";

import { EditPopup } from "./EditableField";
import { FakeReferenceTextField } from "./FakeReferenceTextField";

const EDIT_HINT = "Double click to edit";

const zeroToEmpty = (value) => (value === 0 ? "" : value);
const emptyToZero = (value) => (value === "" ? 0 : value);

const arePortCellsEqual = (prev, next) =>
	prev.isOSFCUser === next.isOSFCUser &&
	prev.record?.id === next.record?.id &&
	prev.record?.terminal_id === next.record?.terminal_id &&
	prev.record?.[prev.source] === next.record?.[next.source] &&
	prev.record?.[`${prev.source}_name`] === next.record?.[`${next.source}_name`];

export const PortField = React.memo(({ isOSFCUser, permissions, record, editable, ...props }) => {
	const replaceSource = `${props.source}_name`;

	if (!isOSFCUser) {
		return <FakeReferenceTextField {...props} record={record} replaceSource={replaceSource} />;
	}

	return (
		<EditPopup
			editable={typeof editable === "function" ? editable(record) : editable}
			record={record}
			source={props.source}
			resource={props.resource}
			basePath={props.basePath}
			permissions={permissions}
			additionalParams={props.additionalParams}
			onSuccess={props.onSuccess}
			edit={
				<PortSelectInput
					autoFocus
					source={props.source}
					label={props.label}
					terminalId={record?.terminal_id}
					format={zeroToEmpty}
					parse={emptyToZero}
				/>
			}
			render={({ openPopup, className }) =>
				record?.[props.source] != null ? (
					<FakeReferenceTextField
						{...props}
						record={record}
						replaceSource={replaceSource}
						className={className}
						onDoubleClick={openPopup}
						title={openPopup ? EDIT_HINT : undefined}
					/>
				) : (
					<div title={openPopup ? EDIT_HINT : undefined} className={className} onDoubleClick={openPopup}>
						&nbsp;
					</div>
				)
			}
		/>
	);
}, arePortCellsEqual);

PortField.defaultProps = {
	addLabel: true,
};
